(function () {
  const sections = document.querySelectorAll("[data-fc]");
  if (!sections.length) return;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  sections.forEach((section) => {
    // Quantity controls
    section.querySelectorAll("[data-fc-qty]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const form = btn.closest("form");
        if (!form) return;
        const input = form.querySelector("[data-fc-qty-input]");
        if (!input) return;

        const cur = Math.max(1, Number(input.value || 1));
        const next = btn.dataset.fcQty === "inc" ? cur + 1 : Math.max(1, cur - 1);
        input.value = String(next);
      });
    });

    // Variant select -> hidden variant id
    section.querySelectorAll("[data-fc-variant-select]").forEach((select) => {
      select.addEventListener("change", (e) => {
        const form = e.target.closest("form");
        if (!form) return;
        const hidden = form.querySelector("[data-fc-variant-id]");
        if (!hidden) return;
        hidden.value = e.target.value;
      });
    });

    // Slider
    const slider = section.querySelector("[data-fc-slider]");
    const track = section.querySelector("[data-fc-track]");
    if (!slider || !track) return;

    const slides = Array.from(track.querySelectorAll("[data-fc-slide]"));
    const btnPrev = slider.querySelector("[data-fc-prev]");
    const btnNext = slider.querySelector("[data-fc-next]");
    const dotsWrap = slider.querySelector("[data-fc-dots]");

    function gapPx() {
      const styles = getComputedStyle(track);
      const gap = styles.columnGap || styles.gap || "0px";
      return Number(String(gap).replace("px", "")) || 0;
    }

    function slideW() {
      const first = slides[0];
      if (!first) return track.clientWidth;
      return first.getBoundingClientRect().width || track.clientWidth;
    }

    // How many cards are visible per "page" right now (responsive)
    function cardsPerView() {
      const w = slideW();
      const g = gapPx();
      const step = w + g;
      if (!step) return 1;

      // +g because last card doesn't need trailing gap
      const approx = Math.round((track.clientWidth + g) / step);
      return clamp(approx, 1, slides.length || 1);
    }

    function totalPages() {
      const per = cardsPerView();
      return Math.max(1, Math.ceil((slides.length || 1) / per));
    }

    function pageWidth() {
      // Testimonials-style: one page = viewport width
      return track.clientWidth;
    }

    function currentPage() {
      const pw = pageWidth();
      if (!pw) return 0;
      return clamp(Math.round(track.scrollLeft / pw), 0, totalPages() - 1);
    }

    function scrollToPage(p) {
      const pw = pageWidth();
      track.scrollTo({ left: p * pw, behavior: "smooth" });
    }

    function stepPage(dir) {
      scrollToPage(currentPage() + dir);
    }

    function buildDots() {
      if (!dotsWrap) return;

      dotsWrap.innerHTML = "";
      const pages = totalPages();
      const active = currentPage();

      for (let i = 0; i < pages; i++) {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "koffi-fc__dot" + (i === active ? " is-on" : "");
        b.setAttribute("aria-label", `Go to page ${i + 1}`);
        b.addEventListener("click", () => scrollToPage(i));
        dotsWrap.appendChild(b);
      }
    }

    function setDotsActive(p) {
      if (!dotsWrap) return;
      const dots = Array.from(dotsWrap.querySelectorAll(".koffi-fc__dot"));
      dots.forEach((d, idx) => d.classList.toggle("is-on", idx === p));
    }

    // Initial
    buildDots();

    // Arrows
    btnPrev && btnPrev.addEventListener("click", () => stepPage(-1));
    btnNext && btnNext.addEventListener("click", () => stepPage(1));

    // Sync dots on scroll (per page, not per card)
    let raf = null;
    track.addEventListener("scroll", () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setDotsActive(currentPage()));
    });

    // Rebuild dots on resize (cardsPerView changes)
    let rAf = null;
    window.addEventListener("resize", () => {
      if (rAf) cancelAnimationFrame(rAf);
      rAf = requestAnimationFrame(() => buildDots());
    });

    // Keyboard
    track.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") stepPage(-1);
      if (e.key === "ArrowRight") stepPage(1);
    });
  });
})();
